<template>
  <div class="header">
    <div class="top-logo"><img src="../../../assets/images/huangshan/logo.png" alt=""></div>
    <div class="topbg">
      <div class="top">
        <HeaderBar
          v-if="!isEnglish"
          :width="pageWidth"
          :bgColor="bgColor"
          :registerTextColor='registerTextColor'
          :loginTextColor="loginTextColor"
        />
        <div class="top-nav-left">黄山旅游发展股份有限公司旅游服务平台</div>
      </div>
    </div>
    <div class="content">
      <div class="right">
        <div class="nav" v-if="!isEnglish">
          <div
            class="tab-item"
            v-for="(item, index) in tabList"
            :key="item.value + index"
            :class="{on: item.routeName === value}"
            @click="onTabClick(item)"
          >
            {{ item.label }}
            <div
              v-if="item.routeName === value && ShowChild"
              class="child-keqi"
            >
              <span
                v-for="(sitem, sIndex) in item.children"
                :key="sitem.value"
                :class="{on: childIndex === sIndex}"
                @click="onTabClick(sitem, sIndex)"
              >
                {{ sitem.label }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiGet } from "@/fetch/api";
import { mapState } from "vuex";
import HeaderBar from "./headerBar";

export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: "home"
    },
    isEnglish:{
      type: Boolean,
      default: false
    },
    Selectlanguage:{
      type: String,
      default: "chinese"
    }
  },
  components: {
    HeaderBar,
  },
  data() {
    return {
      showLoginModel:false,
      pageWidth: 130,
      bgColor: '#fff',
      registerTextColor: '#fff',
      loginTextColor: '#fff',
      ShowChild: false,
      childIndex: undefined,
    };
  },
  computed: {
    ...mapState(["login", "userInfo", "m_id",''])
  },
  methods: {
    onTabClick(data, sIndex) {
      if (data.linkUrl === this.value) {
        return;
      }
      if (data.routeName === 'keqiOnlineBook') {
        this.ShowChild = data.value === 'onlineBook';
      } else {
        this.ShowChild = false
      }
      if (sIndex >= 0) {
        this.childIndex = sIndex;
      }
      this.$emit("change", data);
    },
    loginChange(bool, isLoginRegister) {
      this.$parent.loginChange(bool, isLoginRegister)
    },
    goto(type){
      if (type === 'chinese') {
        this.$router.push('/index?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id));
          localStorage.setItem('selectValue','bameiHomePage');
      }
      if (type === 'English') {
        this.$router.push('/Eindex?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id));
      }
      this.$emit("lang", type);
    }
  }
}
</script>
<style scoped lang="scss">
.header {
  width: 1200px;
  margin: 15px auto 0 auto;
  height: 110px;
  overflow: hidden;
  position: relative;
  .top-logo{
    position: relative;
    z-index: 2;
    width: 60px;
    height: 76px;
    float: left;
  }
  .topbg {
    width: 1100px;
    background:#fff ;
    height: 30px;
    margin: 0 auto;
    float: left;
    text-align: left;
    .top {
      width: 1100px;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      color: #333;
      display: flex;
      flex-direction: row-reverse;
      position: relative;
      .header-top-bar {
        width: 130px;
        height: auto;
      }
      .login {
        cursor: pointer;
      }
      .regsiter {
        cursor: pointer;
        color:#126c42 ;
        padding-left: 0px;
      }
      .language {
        clear: both;
        span{
          text-align: center;
          line-height: 22px;
          display: block;
          float: left;
          width: 54px;
          cursor: pointer;
          height: 22px;
          border: 1px solid #126c42;
          color: #fff;
        }
        .on{
          color: #fff;
          background:#126c42;
        }
      }
      .top-nav {
        color: #696969;
        margin-right: 10px;
      }
      .top-nav-left {
        position: absolute;
        left: 10px;
        font-size: 22px;
        color: #006953;
      }
    }
  }
  .content {
    width: 1100px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    display: flex;
    position: relative;
    z-index: 4;
    display: inline-block;
    .logo {
      margin-right: 10px;
      padding: 5px 0;
      img {
        width: 293px;
        height: 76px;
        vertical-align: middle;
      }
    }
    .nav {
      display: flex;
      .tab-item {
        width: 85px;
        text-align: center;
        color: #333;
        font-size: 18px;
        cursor: pointer;
        .child-keqi {
          position: fixed;
          background:#515467;
          z-index: 5;
          width: 125px;
          padding: 10px 0;
          span {
            display: block;
            height: 36px;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
            opacity: 0.5;
          }
          .on {
            opacity: 1;
          }
        }
      }
      .on {
        color: #4e8f8b;
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/huangshan/components/header.vue